import { useQuery, UseQueryOptions } from 'react-query';

import { useService } from '@core/inversify-react';

import { GetInspectionReportRepoType, IGetInspectionReportRepo } from '../repos';
import { IInspectionReport } from '../interfaces';

export const useInspectionReport = (id?: string, options?: UseQueryOptions<IInspectionReport, Error, IInspectionReport, string[]>) => {
  const getInspectionReportRepo = useService<IGetInspectionReportRepo>(GetInspectionReportRepoType);

  return useQuery<IInspectionReport, Error, IInspectionReport, string[]>(
    ['branch-inspection-report', id || ''],
    async ({ queryKey }) => {
      const [, id] = queryKey;
      const result = await getInspectionReportRepo.execute(id);

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    options,
  );
};
